import {MutationTree} from "vuex";
import {EventsState} from "../types/EventsState";
import Vue from 'vue';

export const mutations: MutationTree<EventsState> = {
    setEvents(state, data) {
        state.list = data;
        state.isLoaded = true;
    },
    setSelected(state, value: string) {
        state.selected = value;
    },
    resetIsLoaded(state) {
        state.isLoaded = false;
    },
    setWelcomeTourDone(state, {index, value}) {
        Vue.set(state.list[index], 'isWelcomeTourDone', value);
    }
}